export const NAV4_OPT_OUT_FEEDBACK_GROUP_ID = 'nav4-opt-out' as const;
export const NAV4_SIDEBAR_FEEDBACK_GROUP_ID = 'nav4-sidebar' as const;

// JSM Project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/NAV4
export const ENTRYPOINT_ID_NAV4 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
